<template>
    <div v-if="!isLoading">
        <div class="f-head">
            <div class="dropdown">
                <a @click="dropDow = !dropDow" class="btn btn-theme bg-gray no-border-box border-right-box d-block" aria-expanded="false">
                    {{ label }}
                    <i class="mdi mdi-chevron-down float-end"></i>
                </a>
                <div class="dropdown-menu" :class="{ 'show': dropDow }">
                    <a 
                        v-for="item in defaults" 
                        :key="item.id" 
                        class="dropdown-item" 
                        :class="{ 'active': isSelected(item.id) }"
                        @click="addToSelection(item.id)"
                    >
                        {{ item.name }}
                    </a>
                </div>
            </div>
        </div>
        <div class="f-content">
            <span 
                v-for="item in selectedItems"
                :key="item.id"
                class="my-badge color-box tag-0"
                @click="removeItem(item.id)"
                style="margin-right:5px; cursor:pointer;"
            >
                {{ item.name }} <i class="mdi mdi-close"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppFilterSelect',
    props: {
        defaults: {
            type: Array,
            required: true
        },
        active: {
            type: [String, Number, Array],
            required: false,
            default: () => []
        },
        label: {
            type: [String, Number],
            required: true
        },
    },
    data() {
        return {
            dropDow: false,
            activeValues: [],
            isLoading: true
        };
    },
    computed: {
        selectedItems() {
            return this.defaults.filter(item => this.activeValues.includes(item.id.toString()));
        }
    },
    mounted() {
        this.setDefaultValue();
    },
    methods: {
        setDefaultValue() {
            if (Array.isArray(this.active)) {
                this.activeValues = [...this.active];
            } else if(this.active !== undefined && this.active !== null && this.active !== '' && this.active !== 0) {
                this.activeValues = [this.active];
            }
            this.isLoading = false;
        },
        addToSelection(id) {
            if (!this.activeValues.includes(id)) {
                console.log('Adding to selection:', id);
                console.log('Current active values:', this.activeValues);
                this.activeValues.push(id.toString());
                this.$emit('handleSet', this.label, [...this.activeValues]);
                this.dropDow = false; // fecha o dropdown após a seleção
            }
        },
        isSelected(id) {
            return this.activeValues.includes(id);
        },
        removeItem(id) {
            this.activeValues = this.activeValues.filter(val => val !== id.toString());
            this.$emit('handleSet', this.label, [...this.activeValues]);
        }
    }
};
</script>
<style scoped>
.dropdown-menu{
    max-height: 300px;
    overflow-y: auto;
    width: 190px;
    margin-top: 12px;
}
.dropdown-item.active {
    background-color: #f0f0f0;
    font-weight: bold;
}
</style>